import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { get } from 'lodash';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import PhoneInput from 'yoda-account-components/lib/components/PhoneInput/PhoneInput';
import regex from 'yoda-account-components/lib/common/regex';
import Button from 'yoda-core-components/lib/components/Button';
import { ModalBox } from 'yoda-core-components/lib/deprecated/ModalBox/ModalBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import { enableInputFieldMaskFix } from 'yoda-account-components/lib/common/Constants';
import PromoEmail from './PromoEmail';
import * as styles from './PromoSMSEmailWrapper.css';

const cx = classNames.bind(styles);

class PromoSMSEmailForm extends Component {
    static defaultProps = {
        featureFlags: {},
        messagesTexts: {},
        preferences: {},
        isPromoChecked: false,
        accountDetails: {},
    };

    static propTypes = {
        featureFlags: PropTypes.object,
        messagesTexts: PropTypes.object,
        preferences: PropTypes.object,
        isPromoChecked: PropTypes.bool,
        accountDetails: PropTypes.object,
        actions: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            isPhoneValid: true,
            isEmailValid: true,
            phoneNumber: '',
            email: '',
            isEmptyEmail: false,
            analyticsData: {},
            isLoading: false,
        };
        this.phoneValidated = this.phoneValidated.bind(this);
        this.handleEmailInfo = this.handleEmailInfo.bind(this);
        this.handleSignup = this.handleSignup.bind(this);
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { actions } = this.props;
        if (
            nextProps?.accountDetails?.promotionalDetails?.showSuccessModal &&
            actions?.promotionalAnalyticsAction
        ) {
            actions.promotionalAnalyticsAction(this.state.analyticsData);
        } else if (
            !nextProps?.accountDetails?.promotionalDetails?.showSuccessModal &&
            nextProps?.accountDetails?.promotionalDetails?.errorResponse &&
            actions?.promotionalAnalyticsAction
        ) {
            const analyticsData = {
                ...this.state.analyticsData,
                ...nextProps?.accountDetails?.promotionalDetails?.errorResponse,
            };
            analyticsData.trackEvent = 'updateNotificationOptinsDenied';
            actions.promotionalAnalyticsAction(analyticsData);
        }
        this.setState({ isLoading: false });
    }

    handleSignup() {
        const { email, phoneNumber, isPhoneValid, isEmailValid } = this.state;
        const { featureFlags } = this.props;
        const enableMarketingTextMsgs = get(featureFlags, 'enableMarketingTextMsgs', true);
        const enableMarketingEmails = get(featureFlags, 'enableMarketingEmails', true);

        const isEmailConditionMet = enableMarketingEmails
            ? email === ''
                ? true
                : !!isEmailValid
            : true;
        const isPhoneConditionMet = enableMarketingTextMsgs
            ? phoneNumber === ''
                ? true
                : !!isPhoneValid
            : true;

        if (isEmailConditionMet && isPhoneConditionMet && (email || phoneNumber)) {
            const { actions } = this.props;
            const payload = {
                textMessage: !!(phoneNumber !== '' && isPhoneValid),
                phoneNumber,
                email: !!(email !== '' && isEmailValid),
                emailId: email,
            };
            const analyticsData = {
                trackEvent: 'updateNotificationOptins',
            };
            if (payload?.email && payload?.emailId) {
                analyticsData.preferences = [
                    {
                        optinType: 'email',
                        optinFlag: 'yes',
                        notificationType: 'marketing',
                        source: 'promotional signup',
                    },
                ];
            }
            if (payload?.textMessage && payload?.phoneNumber) {
                analyticsData.preferences = [
                    {
                        optinType: 'sms',
                        optinFlag: 'yes',
                        notificationType: 'marketing',
                        source: 'promotional signup',
                    },
                ];
            }
            if (
                payload?.textMessage &&
                payload?.phoneNumber &&
                payload?.email &&
                payload?.emailId
            ) {
                analyticsData.preferences = [
                    {
                        optinType: 'email',
                        optinFlag: 'yes',
                        notificationType: 'marketing',
                        source: 'promotional signup',
                    },
                    {
                        optinType: 'sms',
                        optinFlag: 'yes',
                        notificationType: 'marketing',
                        source: 'promotional signup',
                    },
                ];
            }
            this.setState({ analyticsData });
            this.setState({ isLoading: true });
            actions.submitPromotionalDetails(payload);
        } else if (!email) {
            this.setState({ isEmptyEmail: true });
        }
    }

    handleEmailInfo(emailInfo) {
        const { email, isEmailValidInput } = emailInfo;
        this.setState({ isEmailValid: isEmailValidInput, email, isEmptyEmail: false });
    }

    clearBtn = (actions) => {
        actions.closePromotionalSuccessModal();
    };

    phoneValidated(istrue, phoneNumber) {
        const validPhoneDigit =
            phoneNumber.length <= 14 && regex.createAccount.phoneMask.test(phoneNumber);
        const validPhoneNum =
            validPhoneDigit && regex.createAccount.strictPhoneNumber.test(phoneNumber);
        const setPhoneNumber = (validPhoneDigit && validPhoneNum) || phoneNumber.length === 0;
        this.setState({ isPhoneValid: setPhoneNumber, phoneNumber });
        this.setState({ phoneNumber });
    }

    render() {
        const {
            featureFlags,
            messagesTexts,
            preferences,
            accountDetails,
            actions,
            isPromoChecked,
        } = this.props;
        const { isEmptyEmail } = this.state;
        const {
            promotionalSMSEMail: { signupLabel, startShoppingLabel, successModalDescription } = {},
        } = messagesTexts;
        const enableMarketingTextMsgs = get(featureFlags, 'enableMarketingTextMsgs', true);
        const enableMarketingEmails = get(featureFlags, 'enableMarketingEmails', true);
        let signupServiceErrMessage = get(
            accountDetails,
            'promotionalDetails.errorResponse.errorMessage',
            ''
        );
        if (enableMarketingTextMsgs && enableMarketingEmails) {
            if (this.state.phoneNumber === '' && isEmptyEmail) {
                signupServiceErrMessage =
                    preferences?.promotionalSignup?.emptyEmailMobileErrorMessage || '';
            }
        } else if (!enableMarketingTextMsgs && isEmptyEmail) {
            signupServiceErrMessage = preferences?.promotionalSignup?.emptyEmailErrorMessage || '';
        } else if (
            enableMarketingTextMsgs &&
            !enableMarketingEmails &&
            this.state.phoneNumber === '' &&
            isEmptyEmail
        ) {
            signupServiceErrMessage = preferences?.promotionalSignup?.emptyMobileErrorMessage || '';
        }

        const emptyMobileErrorMessage =
            preferences?.promotionalSignup?.emptyMobileErrorMessage || '';
        const showThankyouModal = get(accountDetails, 'promotionalDetails.showSuccessModal', false);
        const convertLabelToAnimatingLegend = true;
        return (
            <>
                <div
                    className={dt([
                        signupServiceErrMessage && '!mt-4',
                        signupServiceErrMessage && '!mb-6',
                        'sm:w-full',
                        'lg:m-auto',
                        'text-left',
                    ])}
                >
                    <MessageBox
                        automationId="promotionalsms-errorMessage"
                        showMessageTypeIcon
                        showMessage={signupServiceErrMessage}
                        type="error"
                        level="section"
                        title={signupServiceErrMessage}
                        hasClose={false}
                    />
                </div>
                {this.state.isLoading && <Loader keepOverlay />}
                <div className={dt(['sm:w-full', 'lg:m-auto'])}>
                    {enableMarketingEmails && (
                        <PromoEmail
                            featureFlags={featureFlags}
                            preferences={preferences}
                            emailInfo={this.handleEmailInfo}
                        />
                    )}
                    {enableMarketingTextMsgs && (
                        <div className={`${cx('phoneInputWrapper')} ${dt(['mb-6'])}`}>
                            <PhoneInput
                                isPhoneValidated={this.phoneValidated}
                                labelValue="Mobile Number"
                                placeHolder=""
                                convertLabelToAnimatingLegend={convertLabelToAnimatingLegend}
                                value={this.state.phoneNumber}
                                isOnBlurRequired={!!this.state.phoneNumber}
                                enableInputFieldMaskFix={enableInputFieldMaskFix}
                                clearInputError={!this.state.phoneNumber}
                                showTickIcon={false}
                                isRegexStrict
                                newIconForPersonalInfoAndPreferences
                                phoneInputId="promo-phone"
                                inputErrorMessage={emptyMobileErrorMessage}
                            />
                        </div>
                    )}
                    <Button
                        type="button"
                        automationId="promo-signup"
                        isDisabled={!isPromoChecked}
                        size="Lg"
                        className={`${cx('signUpButton')} ${dt([
                            'w-full',
                            'lg:w-[300px]',
                            'm-auto',
                            'mb-6',
                        ])}`}
                        onClick={this.handleSignup}
                    >
                        {signupLabel}
                    </Button>
                    <ModalBox
                        automationId="at-promotions-subscription-success"
                        showModal={showThankyouModal}
                        title="Thank you"
                        defaultHeader
                        onClose={() => {
                            this.clearBtn(actions);
                        }}
                        defaultCloseBtn
                        modalTitleTheme={dt(['sm:!text-xlarge', 'lg:text-large', 'text-left'])}
                        modalHeaderTheme={dt(['items-left', '!items-center'])}
                        modalContentTheme={dt(['!mt-0'])}
                        wrapperAutomationId="at-promo-wrapper"
                    >
                        <p className={dt(['mt-4', 'text-left', 'sm:text-medium', 'lg:text-small'])}>
                            {successModalDescription}
                        </p>
                        <Button
                            type="button"
                            automationId="thankyou_startshopping"
                            size="Md"
                            className={`${cx('button')} ${dt([
                                'mt-6',
                                'sm:w-full',
                                'lg:w-auto',
                                'lg:float-right',
                            ])}`}
                            onClick={() => {
                                window.location.pathname = '/';
                            }}
                        >
                            {startShoppingLabel}
                        </Button>
                    </ModalBox>
                </div>
            </>
        );
    }
}

export default PromoSMSEmailForm;
